export const domainConfigs = [
  {
    domain: 'alvoradanatural',
    title: 'Alvorada Natural',
    favicon: '/assets/icons/logo_alvorada.ico',
  },
]
